<template>
    <div class="overlay">
        <div class="overlay-bg" @click="closeOverlay()"></div>
        <div class="d-flex justify-content-center full-height ">
            <div class="success-pop text-center">
                <lottie-player src="https://lottie.host/98dfe69e-bdb0-4dee-97a8-7b1571476098/judqILgr3a.json" background="transparent" speed="1" style="width: 150px; height: 150px; margin: 0 auto !important;" loop autoplay></lottie-player>
                <!--<img src="https://business.pixcham.com/icons/like.svg" class="img-fluid m-auto" alt="good" width="100px">-->
                <!--<h3  :v-html="rawHtml" >{{$t(message)}}</h3>-->
                <h3><div v-html="$t(message)"></div></h3>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "SuccessPop",
        props: ["msg", "redirect", "whoCall"],
        data() {
            return {
                message: this.msg,
                onlineMessage: null,
                route: this.redirect,
                calledBy: this.whoCall
            }
        },
        watch: {
            onlineMessage( newValue, oldValue ) {
                console.log('onlineMessage', newValue, oldValue);
                if( newValue !== oldValue ) {
                    this.message = newValue;
                    this.$store.commit('updateSuccessOpenMessage', null );
                    this.route = '/';
                }
            }
        },
        beforeDestroy() {
            this.closeOverlay();
        },
        computed: {
            getMessage() {
                this.onlineMessage = this.$store.getters.successOpenMessage;
            }
        },
        mounted() {

            
            try {
                this.getMessage;
            } catch (e) {
                console.log('Error', e);
            }

            let jquery = document.createElement('script')
                jquery.setAttribute('type', 'text/javascript')
                jquery.setAttribute('src', 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js')
                document.head.appendChild(jquery)
            //console.log('Success mounted');
            //console.log(this.message);
            //let savedLocations = ( this.redirect === '/challenge-setup' && Object.keys( this.$store.getters.locationsStored ).length ? true : false );
           // console.log(this.route, this.redirect, this.$store.getters.locationsStored, savedLocations, Object.keys( this.$store.getters.locationsStored ).length );
           //console.log(this.route, this.redirect );
            
            if( this.calledBy && this.calledBy === 'challenge-setup' && this.route === '/challenge-setup' && this.redirect !== '/challenge-setup' ) {
                setTimeout(this.closeOverlay, 2700);
            } else if( this.calledBy && this.calledBy === 'challenge-setup' && this.route === '/challenge-setup' ) {
                setTimeout(this.closeOverlay, 2700);
            } else {
                setTimeout(this.redirectTo, 2700);
            }
        },
        methods: {
            closeOverlay() {
                //console.log('close Success Pop');
                this.$store.commit('updateSuccessOpen', false)
            },
            redirectTo() {
                
                //let savedLocations = ( this.route === '/challenge-setup' && Object.keys( this.$store.getters.locationsStored ).length ? true : false );
                //console.log('redirectTo', savedLocations , this.$store.getters.locationsStored);
                //console.log(this.route);
                

                if( this.calledBy && this.calledBy === 'challenge-setup' &&  this.route === '/challenge-setup'  ){ this.closeOverlay(); }
                else if (this.route != null) {
                    this.$router.push({ path: this.route })
                }
            }
        }
    }
</script>